// The frontend writes this cookie and the backend reads it: a second copy of the contract would drift silently.
export const LUMIR_ENTRY_COOKIE: string = 'lumir_entry';

export const LUMIR_ENTRY_SOURCES = ['landing', 'campaign', 'search', 'referral', 'product', 'direct'] as const;
export type LumirEntrySource = (typeof LUMIR_ENTRY_SOURCES)[number];

export const LUMIR_ENTRY_TEXT_KEYS = ['ref', 'us', 'um', 'uc'] as const;
export type LumirEntryTextKey = (typeof LUMIR_ENTRY_TEXT_KEYS)[number];

// Code points, not UTF-16 units.
export const LUMIR_ENTRY_TEXT_MAX_CHARS: number = 100;

export interface LumirEntryCookie {
  v: 1;
  src: LumirEntrySource;
  ref?: string;
  us?: string;
  um?: string;
  uc?: string;
  at?: string;
}
